import React from 'react';
import sidekick from '@last-rev/contentful-sidekick-util';
import PropTypes from 'prop-types';
import cx from 'clsx';
import styles from './ModuleMultiColumnvideos.module.scss';
import ElementVideo, { ElementVideoPropTypes } from '../ElementVideo';
import ElementLink from '../ElementLink';
import VideoCard from '../ModuleCard/VideoCard';

export const ModuleMultiColumnvideosPropTypes = {
  _id: PropTypes.string.isRequired,
  _contentTypeId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  videos: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape(ElementVideoPropTypes)])).isRequired,
  viewMoreLinkText: PropTypes.string.isRequired,
  className: PropTypes.string,
  themeClassName: PropTypes.string
};

function ModuleMultiColumnvideos({ _id, className = '', subtitle = null, title, videos, viewMoreLinkText, themeClassName = "" }) {
  const slug = "video-library"
  return (
    <section data-testid="ModuleMultiColumnvideos" className={styles.ModuleMultiColumnvideos}>
      <div className={styles.moduleContainerWrap}>
        <div className={styles.sectionHeaderWrap}>
          <div className={styles.sectionTitleWrap} {...sidekick(_id, 'title')}>
            <h2 className={styles.sectionTitle} data-testid="ModuleTitle">
              {title}
            </h2>
            {subtitle ? (
              <div className={styles.subtitleWrap} {...sidekick(_id, 'subtitle')}>
                <h5 className={styles.subtitle} data-testid="ModuleSubtitle">
                  {subtitle}
                </h5>
              </div>
            ) : null}
          </div>


          {viewMoreLinkText ? (
            <div className={styles.viewMoreTextLinkWrap}>
              <ElementLink
                href="/video-library"
                isModal={false}
                download={false}
                linkText={viewMoreLinkText}
                className={styles.viewMoreTextLink}>
                {viewMoreLinkText}
              </ElementLink>
            </div>
          ) : null}
        </div>

        <div className={styles.moduleContainerRow}>
          {videos && videos.length
            ? videos.map((video) => (
              <div className={styles.videoWrap} key={video._id} data-testid="ModuleVideoWrap">
                <VideoCard
                  key={video?._id}
                  _id={video?._id}
                  headerText={video?.videoTitle}
                  summaryText={video?.videoSummary}
                  image={video?.videoCardImage}
                  slug={`/${slug}/${video?.slug}`}
                  parent="home"
                
                />
              </div>
            ))
            : null}
        </div>


      </div>
    </section>
  );
}
ModuleMultiColumnvideos.propTypes = ModuleMultiColumnvideosPropTypes;


export default ModuleMultiColumnvideos;
